export const blockIconsMapsMyLocation = (
	<span className='material-symbols-outlined'>my_location</span>
);
